type WinContext = {
  state?: any;
  online?: { enabled?: boolean } | null;
  t?: (key: string, fallback?: string) => string;
  stopMusic?: () => void;
  closeModal?: (id: string) => void;
  setOfflineGameOverUI?: (isOver: boolean) => void;
  initGame?: (mode: string) => void;
  beatlineHeardCommitMatch?: (mode: string) => void;
  confetti?: (...args: any[]) => void;
  onlineSendAction?: (type: string, payload: any) => void;
};

function safeCall(fn?: Function, ...args: unknown[]): void {
  try { if (typeof fn === 'function') fn(...args); } catch (_) {}
}

function tr(ctx: WinContext, key: string, fallback: string): string {
  try {
    return typeof ctx.t === 'function' ? ctx.t(key, fallback) : fallback;
  } catch (_) {
    return fallback;
  }
}

export function endGameFromTypeScript(winner: number, ctx: WinContext = {}): { handled: boolean } {
  const state = ctx.state || (window as any).state;
  if (!state) return { handled: false };

  try { state.gameEnded = true; } catch (_) {}
  safeCall(ctx.setOfflineGameOverUI, true);

  const titleEl = document.getElementById('win-title');
  const nameEl = document.getElementById('winner-name');
  const winModal = document.getElementById('win-modal') as HTMLElement | null;

  if (titleEl) titleEl.textContent = tr(ctx, 'win_title', 'WINNER!');
  if (nameEl) nameEl.textContent = `${tr(ctx, 'player', 'PLAYER')} ${winner}`;
  if (winModal) winModal.style.display = 'flex';

  safeCall(ctx.beatlineHeardCommitMatch, state.mode);
  safeCall(ctx.confetti || (window as any).confetti, { particleCount: 150, spread: 80, zIndex: 9999999 });
  return { handled: true };
}


function clearActionButtonsForSpecialEnd(): void {
  const btnCheck = document.getElementById('btn-check') as HTMLButtonElement | null;
  const btnNext = document.getElementById('btn-next') as HTMLButtonElement | null;
  if (btnCheck) { btnCheck.style.display = 'none'; btnCheck.disabled = true; }
  if (btnNext) { btnNext.style.display = 'none'; btnNext.disabled = true; }
  const deck = document.getElementById('deck-zone');
  if (deck) deck.innerHTML = '';
}

function formatCompactMs(ms: number): string {
  const totalSeconds = Math.max(0, Math.round(ms / 1000));
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  if (m <= 0) return `${s}s`;
  return `${m}m ${s}s`;
}

function speedrunElapsedMs(state: any): number {
  if (!state) return 0;
  if (state.speedrunEnded && parseInt(String(state.speedrunFinalElapsedMs || 0), 10) > 0) {
    return parseInt(String(state.speedrunFinalElapsedMs || 0), 10) || 0;
  }
  return Math.max(0, Date.now() - (parseInt(String(state.speedrunStartAt || Date.now()), 10) || Date.now()));
}

export function endTimeAttackFromTypeScript(ctx: WinContext = {}): { handled: boolean } {
  const state = ctx.state || (window as any).state;
  if (!state || !state.timeAttack || state.timeAttackEnded) return { handled: false };
  state.timeAttackEnded = true;
  safeCall((ctx as any).stopTimeAttackTimer);
  safeCall(ctx.stopMusic);
  clearActionButtonsForSpecialEnd();

  const titleEl = document.getElementById('win-title');
  const nameEl = document.getElementById('winner-name');
  const winModal = document.getElementById('win-modal') as HTMLElement | null;
  if (titleEl) titleEl.textContent = tr(ctx, 'time_up', 'TIJD VOORBIJ');
  if (nameEl) nameEl.textContent = `${parseInt(String(state.p1?.score || 0), 10) || 0} ${tr(ctx, 'points_word', 'punten')}`;
  safeCall(ctx.setOfflineGameOverUI, true);
  if (winModal) winModal.style.display = 'flex';
  safeCall(ctx.beatlineHeardCommitMatch, state.mode);
  safeCall(ctx.confetti || (window as any).confetti, { particleCount: 150, spread: 80, zIndex: 9999999 });
  return { handled: true };
}




function beatlineRenderSurvivalGameOverCardFromTypeScript(state: any): void {
  // beatline_survival_ts_gameover_card_repair_v5
  try {
    const lives = parseInt(String(state && typeof state.survivalLives !== 'undefined' ? state.survivalLives : 0), 10);
    if (!state || lives > 0 || !state.activeCard) return;

    const old = document.getElementById('beatline-survival-gameover-card-wrap');
    if (old) old.remove();

    const winnerName = document.getElementById('winner-name');
    if (!winnerName) return;

    const song = state.activeCard || {};
    const title = String(song.title || song.name || '').trim();
    const artist = String(song.artist || song.artist_name || song.artists || '').trim();
    const year = String(song.year || '').trim();

    const esc = function(value: string): string {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    };

    const wrap = document.createElement('div');
    wrap.id = 'beatline-survival-gameover-card-wrap';
    wrap.className = 'modal-card-view beatline-survival-gameover-card-view';

    const card = document.createElement('div');
    card.className = 'card revealed correct beatline-survival-gameover-card';
    if (song.id) card.setAttribute('data-id', String(song.id));

    card.innerHTML =
      '<div class="card-year">' + esc(year || '?') + '</div>' +
      '<div class="card-title">' + esc(title || 'Onbekende titel') + '</div>' +
      (artist ? '<div class="card-artist">' + esc(artist) + '</div>' : '');

    wrap.appendChild(card);
    winnerName.insertAdjacentElement('afterend', wrap);
  } catch (_) {}
}

export function endSurvivalFromTypeScript(ctx: WinContext = {}): { handled: boolean } {
  const state = ctx.state || (window as any).state;
  if (!state || !state.survival || state.survivalEnded) return { handled: false };

  state.survivalEnded = true;
  safeCall(ctx.stopMusic);
  clearActionButtonsForSpecialEnd();

  const titleEl = document.getElementById('win-title');
  const nameEl = document.getElementById('winner-name');
  const winModal = document.getElementById('win-modal') as HTMLElement | null;

  const lives = parseInt(String(state.survivalLives || 0), 10);
  const score = parseInt(String(state.p1 && typeof state.p1.score !== 'undefined' ? state.p1.score : 0), 10) || 0;

  if (titleEl) titleEl.textContent = lives <= 0 ? 'GAME OVER' : tr(ctx, 'done_title', 'KLAAR');
  if (nameEl) nameEl.textContent = String(score) + ' ' + tr(ctx, 'cards_word', 'kaarten');

  beatlineRenderSurvivalGameOverCardFromTypeScript(state);

  safeCall(ctx.setOfflineGameOverUI, true);
  if (winModal) winModal.style.display = 'flex';
  safeCall(ctx.beatlineHeardCommitMatch, state.mode);

  return { handled: true };
}

export function endSpeedrunFromTypeScript(reason = 'done', ctx: WinContext = {}): { handled: boolean } {
  const state = ctx.state || (window as any).state;
  if (!state || !state.speedrun || state.speedrunEnded) return { handled: false };
  state.speedrunEnded = true;
  state.speedrunFinalElapsedMs = speedrunElapsedMs(state);
  safeCall((ctx as any).stopSpeedrunTimer);
  safeCall(ctx.stopMusic);
  clearActionButtonsForSpecialEnd();

  const penalty = Math.max(0, parseInt(String(state.speedrunPenaltySeconds || 0), 10) || 0);
  const totalMs = state.speedrunFinalElapsedMs + (penalty * 1000);
  const timeTxt = formatCompactMs(totalMs);
  const titleEl = document.getElementById('win-title');
  const nameEl = document.getElementById('winner-name');
  const winModal = document.getElementById('win-modal') as HTMLElement | null;
  if (titleEl) titleEl.textContent = reason === 'out' ? tr(ctx, 'out_short', 'OP') : tr(ctx, 'speedrun_done_title', 'SPEEDRUN KLAAR');
  if (nameEl) nameEl.textContent = penalty > 0 ? `${timeTxt} (+${penalty}s ${tr(ctx, 'penalty_word', 'straf')})` : timeTxt;
  if (winModal) winModal.style.display = 'flex';
  safeCall(ctx.beatlineHeardCommitMatch, state.mode);
  if (reason !== 'out') safeCall(ctx.confetti || (window as any).confetti, { particleCount: 180, spread: 85, zIndex: 9999999 });
  return { handled: true };
}

export function replayFromTypeScript(ctx: WinContext = {}): { handled: boolean } {
  const online = ctx.online;
  const state = ctx.state || (window as any).state;

  if (online && online.enabled) {
    try {
      const winModal = document.getElementById('win-modal');
      const btn = winModal ? winModal.querySelector<HTMLButtonElement>('.btn-main') : null;
      if (btn) {
        btn.disabled = true;
        btn.innerText = tr(ctx, 'wait_opponent_ellipsis', 'WACHTEN OP TEGENSTANDER…');
      }
    } catch (_) {}
    safeCall(ctx.onlineSendAction, 'REMATCH_REQUEST', {});
    return { handled: true };
  }

  safeCall(ctx.stopMusic);
  safeCall(ctx.closeModal, 'win-modal');
  safeCall(ctx.closeModal, 'bonus-modal');

  try {
    if (state) state.gameEnded = false;
    safeCall(ctx.setOfflineGameOverUI, false);
  } catch (_) {}

  const mode = state && state.mode ? String(state.mode) : 'spotify';
  try {
    if (typeof ctx.initGame === 'function') ctx.initGame(mode);
    else if (typeof (window as any).initGame === 'function') (window as any).initGame(mode);
    else window.location.reload();
  } catch (_) {
    window.location.reload();
  }
  return { handled: true };
}
